import { Uom } from 'types/schema';

export function allowDecimalQuantity(uom?: Uom | null) {
  if (!uom) {
    return true;
  }
  return ['KILOGRAM'].includes(uom);
}
